import React, { useContext, useEffect, useState } from 'react';
import { AccountContext } from '../../Contexts/main.context';

const ShowClientTheirCitations = () => {
    const { clientActiveLocation } = useContext(AccountContext);
    const [activeLocations, setActiveLocations] = useState([]);
    const [duplicateLocations, setDuplicateLocations] = useState([]);
    const [displayList, setDisplayList] = useState([]);
    const [highlightMonthYear, setHighlightMonthYear] = useState(null);

    useEffect(() => {
        const fetchLocations = async () => {
            if (!clientActiveLocation?.ID) return;

            try {
                const response = await fetch('https://www.lgfantasy.ca/Citations/PHP/client.php', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ script: 'getcitations', clientID: clientActiveLocation.ID }),
                });

                const data = await response.json();
                const active = data.filter(loc => loc.citationStatus?.toLowerCase() === 'active');
                const duplicates = data.filter(loc => loc.citationStatus?.toLowerCase() === 'duplicate');

                setActiveLocations(active);
                setDuplicateLocations(duplicates);
                setDisplayList(active);

                // Get YYYY-MM from the first active citation
                if (active.length && active[0].citationYear) {
                    const year = active[0].citationYear;
                    const month = active[0].citationMonth;
                    console.log(`Setting highlight month/year to: ${year}-${month}`);
                    setHighlightMonthYear(`${year}-${month}`);
                }
            } catch (err) {
                alert('Failed to load citations.');
            }
        };

        fetchLocations();
    }, [clientActiveLocation]);

    const getRowHighlightClass = (citation) => {
        if (!highlightMonthYear || !citation.citationYear) return '';
        const year = citation.citationYear;
        const month = citation.citationMonth;
        const citationMonthYear = `${year}-${month}`;
        return citationMonthYear === highlightMonthYear ? 'alert-success' : '';
    };

    return (
        <div className="container-fluid min-vh-100 py-4">
            <div className="col-48 mx-auto">
                <div className="d-flex justify-content-center fs-6 fw-bold alert-dark p-2 mb-3">
                    <div>{clientActiveLocation?.companyName} - {clientActiveLocation?.theLocation}</div>
                    <div className="ps-3 text-purple">[{clientActiveLocation?.citationCount || 0} Citations]</div>
                </div>

                <div className="d-flex justify-content-center gap-3 mb-3">
                    <button
                        className={`btn ${displayList === activeLocations ? 'btn-success text-white' : 'btn-outline-success'}`}
                        onClick={() => {
                            setDisplayList(activeLocations);
                        }}
                    >
                        Active
                    </button>
                    {/* <button
                        className={`btn ${displayList === duplicateLocations ? 'btn-danger' : 'btn-outline-danger'}`}
                        onClick={() => {
                            setDisplayList(duplicateLocations);
                            setHighlightMonthYear(null); // Don't highlight duplicates
                        }}
                    >
                        Duplicate
                    </button> */}
                    <div className="alert-success fw-bold d-flex align-items-center px-3">Most Recent Citations</div>
                </div>

                {displayList === duplicateLocations && (
                    <div className="alert alert-danger text-center mb-3">
                        Duplicates will be removed by LGO when identified.
                    </div>
                )}

                {/* Header */}
                <div className="d-flex bg-navy text-lemon fs-6 p-3">
                    <div className="col-36 col-md-12">Source</div>
                    <div className="col-12 col-md-36">
                        <span className="d-none d-md-block">Link (click link to view citation)</span>
                        <span className="d-block d-md-none text-center w-100">Link</span>
                    </div>
                </div>

                {/* Rows */}
                {displayList.map((loc, i) => (
                    <div key={i} className={`d-flex px-3 py-2 border-bottom align-items-center ${getRowHighlightClass(loc)}`}>
                        <div className="col-36 col-md-12">{loc.Domain || '-'}</div>

                        {/* Desktop Link */}
                        <div className="d-none d-md-block col-md-36 text-break">
                            {loc.CitationLink ? (
                                <a href={loc.CitationLink} target="_blank" rel="noopener noreferrer">
                                    {loc.CitationLink}
                                </a>
                            ) : '-'}
                        </div>

                        {/* Mobile Link */}
                        <div className="d-block d-md-none col-12 mt-2">
                            {loc.CitationLink ? (
                                <a
                                    href={loc.CitationLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className={`btn btn-sm w-100 text-uppercase text-white ${loc.citationStatus?.toLowerCase() === 'active' ? 'bg-success' :
                                            loc.citationStatus?.toLowerCase() === 'duplicate' ? 'bg-danger' : 'bg-secondary'
                                        }`}
                                >
                                    Link
                                </a>
                            ) : (
                                <span className="text-muted">No Link</span>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ShowClientTheirCitations;
